import React, { FC } from 'react';
import { ReactSelect } from 'components/form/field/react_select';

interface DispensingPharmacyFilterProps {
  value: Array<{ value: any; label: string }>;
  onChange: (values: Array<{ value: any; label: string }>) => void;
  fields: Array<{ value: any; label: string }>;
}

const DispensingPharmacyFilter: FC<DispensingPharmacyFilterProps> = ({
  value,
  onChange,
  fields,
}) => {
  return (
    <ReactSelect
      data-qa-id=""
      label="Dispensing Pharmacy"
      handleOnChange={onChange}
      value={value}
      fields={fields}
      isMulti
    />
  );
};

export default DispensingPharmacyFilter;
